export default __webpack_public_path__ + "static/sprints-second-image-268fc72b29110a7950bc531b19462ba6.jpg";